import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [debugLink, setDebugLink] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDone(true);
      if (data.debug_reset_link) setDebugLink(data.debug_reset_link);
      toast.success(data.message || "Solicitud enviada");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background grid-bg">
      <div className="w-full max-w-md bg-card border border-border rounded-md p-8">
        <Link to="/login" className="text-xs text-muted-foreground inline-flex items-center gap-1.5 mb-4">
          <ArrowLeft className="w-3 h-3" /> Volver
        </Link>
        <div className="overline mb-2">Recuperar acceso</div>
        <h1 className="text-3xl font-black tracking-tight mb-2">¿Olvidaste tu contraseña?</h1>
        <p className="text-sm text-muted-foreground mb-6">
          Ingresa tu correo. Si la cuenta existe, recibirás un enlace de recuperación
          en el email de respaldo asociado.
        </p>

        {done ? (
          <div className="space-y-4">
            <div className="p-4 bg-success/10 border border-success/30 rounded-md text-sm">
              Si la cuenta existe, recibirás un enlace para restablecer la contraseña.
            </div>
            {debugLink && (
              <div className="p-4 bg-warning/10 border border-warning/40 rounded-md text-xs">
                <div className="overline mb-1 text-warning">Debug — email no configurado</div>
                <a href={debugLink} className="font-mono break-all text-primary underline">
                  {debugLink}
                </a>
              </div>
            )}
            <Link to="/login">
              <Button variant="outline" className="w-full">Volver a iniciar sesión</Button>
            </Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4" data-testid="forgot-form">
            <div>
              <Label htmlFor="email" className="text-xs font-bold tracking-wider uppercase">
                Email
              </Label>
              <Input
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1.5"
                data-testid="forgot-email-input"
              />
            </div>
            <Button
              type="submit"
              className="w-full h-11 bg-primary hover:bg-primary/90 font-bold"
              disabled={submitting}
              data-testid="forgot-submit-btn"
            >
              {submitting ? "Enviando…" : "Enviar enlace"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
